/**
 * Form-fill step-by-step guides for the top 10 Indian govt exam application forms.
 * Each guide includes prerequisites, exact steps, common mistakes, and last-minute tips.
 */

export const FORM_GUIDES = [
  {
    slug: "ssc-cgl-application-form-2026-step-by-step",
    exam: "SSC CGL 2026",
    title: "SSC CGL 2026 Application Form — Step-by-Step Apply Online Guide",
    portal: "https://ssc.gov.in/",
    fee_general: "Rs. 100",
    fee_reserved: "Nil (SC/ST/PwD/Women exempt)",
    steps: [
      "Register on OTR (One Time Registration) at ssconline.nic.in with Aadhaar, mobile, email — get OTR ID.",
      "Login to SSC CGL portal with OTR ID and DOB. Click 'Apply' under CGL Notification.",
      "Fill Personal Details — exactly as Class 10 certificate (name, parents, DOB, category).",
      "Fill Educational Qualification — qualifying exam, board, year, percentage.",
      "Choose Post Preference order (ASO, Auditor, Inspector etc) — order matters for tie-break.",
      "Choose 3 Exam Centres in order of preference within home state.",
      "Upload Photo (4 KB-40 KB, JPEG, white background, last 3 months) + Signature (1-12 KB, JPEG).",
      "Pay fee online via SBI Net Banking, UPI or debit/credit card. Save SBI transaction reference.",
      "Submit final application. Take 2 printouts of the application slip + fee receipt.",
    ],
    common_mistakes: [
      "Name mismatch between Class 10 certificate and Aadhaar — application rejected at DV.",
      "Photo with sunglasses/headgear/old date — system rejects but candidate doesn't notice.",
      "Same state code in all 3 centre preferences — system picks only one centre.",
      "Filling Class 12 percentage instead of qualifying graduation percentage.",
    ],
    last_minute: "Apply 7 days before last date — server crashes are common in last 48 hours. Keep scanned Aadhaar + caste certificate + degree mark sheet ready in 100 KB JPEG.",
  },
  {
    slug: "rrb-ntpc-application-form-step-by-step",
    exam: "RRB NTPC",
    title: "RRB NTPC Application Form — Step-by-Step Apply Online Guide",
    portal: "https://www.rrbcdg.gov.in/",
    fee_general: "Rs. 500 (Rs. 400 refundable after CBT-1)",
    fee_reserved: "Rs. 250 (full refund after CBT-1)",
    steps: [
      "Go to rrbapply.gov.in. Click 'New Registration' — enter name, DOB, mobile, email.",
      "Verify mobile + email OTP. Get RRB Registration ID + Password by SMS/email.",
      "Login → Choose RRB Region (e.g., Mumbai, Kolkata, Chennai — only ONE region allowed).",
      "Fill Part-I Personal Details — exactly as Class 10 marksheet.",
      "Fill Part-II Educational Qualifications — degree, year, board/university, percentage.",
      "Choose Post(s) within NTPC — Graduate level: SM, CCM Clerk, Senior Clerk, Goods Guard.",
      "Choose 3 Exam Centres in preferred order from the RRB region you applied to.",
      "Upload Photo (15 KB-40 KB) and Signature (10 KB-40 KB).",
      "Pay Rs. 500/250 via debit card / net banking / UPI. Save txn reference.",
      "Submit and download Application Confirmation.",
    ],
    common_mistakes: [
      "Applying to multiple RRB regions — application automatically rejected.",
      "Wrong DOB causing age criteria fail — RRB does NOT allow correction post-submission.",
      "Choosing centres in different state — RRB allocates based on region availability only.",
    ],
    last_minute: "RRB allows fee refund of Rs. 400 (General) / 250 (SC/ST/Women) only if you appear in CBT-1. So don't skip the exam after applying.",
  },
  {
    slug: "upsc-cse-application-form-step-by-step",
    exam: "UPSC CSE Prelims",
    title: "UPSC CSE Application Form — Step-by-Step DAF Apply Guide",
    portal: "https://upsconline.gov.in/",
    fee_general: "Rs. 100",
    fee_reserved: "Nil (SC/ST/PwBD/Women — full exemption)",
    steps: [
      "Register on OTR at upsconline.gov.in — one-time registration valid for 3 years.",
      "Login with OTR ID + password. Open CSE Prelims notification page.",
      "Click 'Part-I' — fill Name, DOB, Address, Category, Educational Qualification.",
      "Choose preference of UPSC Exam Centre (75 cities, first-come-first-served — fill on Day 1!).",
      "Submit Part-I → Generate Registration ID.",
      "Click 'Part-II' — Pay Rs. 100 fee online (SC/ST/PwBD/Women exempt).",
      "Upload Photo (3 KB-40 KB JPG), Signature, Photo ID Proof, PwBD certificate (if applicable).",
      "Choose Optional Subject for Mains (CSE Mains only — fill in Mains DAF, not Prelims).",
      "Final Submit + Download confirmation page. Print 2 copies.",
    ],
    common_mistakes: [
      "Choosing exam centre late — popular centres (Delhi, Mumbai, Bengaluru) close on Day 1.",
      "Wrong photo dimensions — UPSC strictly enforces 350×350 pixel photo.",
      "Forgetting to verify email/mobile OTR — DAF gets stuck.",
    ],
    last_minute: "UPSC centre allocation is first-come, first-served. Apply on Day 1 to get your preferred centre. Last 48 hours have heavy server load.",
  },
  {
    slug: "ibps-po-application-form-step-by-step",
    exam: "IBPS PO",
    title: "IBPS PO Application Form — Step-by-Step Apply Online Guide",
    portal: "https://www.ibps.in/",
    fee_general: "Rs. 850",
    fee_reserved: "Rs. 175 (SC/ST/PwBD)",
    steps: [
      "Go to ibps.in → CRP PO Notification → 'Apply Online'.",
      "New Candidate → Enter Name, DOB, Mobile, Email. Get Registration ID + Password.",
      "Login → Fill Personal Information, Communication Address, Photo ID Proof type & number.",
      "Educational Qualification — Graduation percentage, university, year of passing.",
      "Choose Bank Preferences — IBPS lets you rank 11 PSU banks (PNB, BoB, Canara etc.).",
      "Choose Exam Centre (Prelims + Mains separately).",
      "Upload Photo (200×230 px, 20-50 KB), Signature (140×60 px, 10-20 KB), Left thumb impression, handwritten declaration.",
      "Pay Rs. 850/175 fee online via debit/credit card, net banking, UPI.",
      "Submit and download application form (keep ID + password safe).",
    ],
    common_mistakes: [
      "Skipping handwritten declaration upload — IBPS rejects applications without it.",
      "Filling bank preference order arbitrarily — top 3 preferences decide your final posting.",
      "Wrong category certificate date — must be from current financial year for OBC-NCL.",
    ],
    last_minute: "Save your IBPS Registration ID and password in 3 places — losing them means re-applying. Photo must be clearly white background.",
  },
  {
    slug: "rrb-alp-application-form-step-by-step",
    exam: "RRB ALP",
    title: "RRB ALP Application Form — Step-by-Step Apply Online Guide",
    portal: "https://www.rrbcdg.gov.in/",
    fee_general: "Rs. 500 (Rs. 400 refundable post-CBT-1)",
    fee_reserved: "Rs. 250 (full refund)",
    steps: [
      "Visit rrbapply.gov.in → Latest Notifications → ALP Apply Online.",
      "New Registration → Name (as on Class 10), DOB, Email, Mobile. Verify OTPs.",
      "Choose RRB Region (only one — Mumbai, Kolkata, Bhubaneswar etc.).",
      "Fill Personal Details exactly as Class 10 certificate.",
      "Fill Educational + Technical Qualification (ITI/Diploma trade, year, percentage).",
      "Choose ALP Trade — Fitter, Electrician, Mechanic, Electronics etc.",
      "Choose 3 Exam Centres within selected RRB region in order.",
      "Upload Photo (15-40 KB) and Signature (10-40 KB).",
      "Pay Rs. 500/250 fee via net banking, debit card or UPI.",
      "Submit and print Application Confirmation Page.",
    ],
    common_mistakes: [
      "Wrong ITI trade code — system rejects at scrutiny.",
      "Not uploading clear Aadhaar — RRB asks for re-upload during DV.",
      "Choosing region different from home district — long travel for CBT.",
    ],
    last_minute: "Class 10 + ITI marksheet must match exactly. Even a single dot/comma difference in name causes rejection at document verification.",
  },
  {
    slug: "ssc-chsl-application-form-step-by-step",
    exam: "SSC CHSL",
    title: "SSC CHSL Application Form — Step-by-Step Apply Online Guide",
    portal: "https://ssc.gov.in/",
    fee_general: "Rs. 100",
    fee_reserved: "Nil (SC/ST/PwD/Women)",
    steps: [
      "Register on SSC OTR at ssconline.nic.in with Aadhaar + mobile.",
      "Login to CHSL notification page. Click Apply.",
      "Fill Personal Details — name and parents' name same as Class 10 certificate.",
      "Educational Qualification — 12th pass / appearing details.",
      "Choose Post preference (LDC, JSA, DEO, DEO Grade A).",
      "Choose 3 Exam Centre preferences within home state.",
      "Upload Photo (4-40 KB JPEG, white background, last 3 months) and Signature.",
      "Pay Rs. 100 fee (General/OBC/EWS male only) via SBI net banking, UPI or card.",
      "Submit and take 2 printouts of application.",
    ],
    common_mistakes: [
      "Wrong stream code in 12th — Arts/Commerce/Science distinction matters for some posts.",
      "Photo with date in left bottom corner is mandatory — many forget.",
    ],
    last_minute: "SSC CHSL re-opens application correction window for 3 days post-deadline — but only for the photo, signature and category. Personal details cannot be changed.",
  },
  {
    slug: "ssc-gd-application-form-step-by-step",
    exam: "SSC GD Constable",
    title: "SSC GD Constable Application Form — Step-by-Step Apply Online Guide",
    portal: "https://ssc.gov.in/",
    fee_general: "Rs. 100",
    fee_reserved: "Nil (Women/SC/ST/Ex-servicemen)",
    steps: [
      "Register on SSC OTR portal at ssconline.nic.in.",
      "Login → Click GD Constable notification → Apply.",
      "Fill Personal Details — exactly as Class 10 / Matriculation certificate.",
      "Fill Educational Qualification — Class 10 passed details.",
      "Choose Force Preference order — BSF, CRPF, CISF, ITBP, SSB, AR, SSF.",
      "Choose 3 Exam Centres in your home state.",
      "Fill Physical Standard self-declaration (height, chest, weight per category).",
      "Upload recent passport photo (4-40 KB) and signature (1-12 KB).",
      "Pay fee of Rs. 100 (General male only).",
      "Submit and take printout.",
    ],
    common_mistakes: [
      "Force preference set arbitrarily — choose based on your domicile / physical strengths.",
      "Wrong tattoo declaration — leads to medical rejection.",
      "Height/chest measurement done at home without tape — under 170 cm men get rejected at PST.",
    ],
    last_minute: "Run 5 km daily for at least 30 days before PET. PET is 24-min run for 5 km for males, 8.5-min for 1.6 km for females.",
  },
  {
    slug: "kvs-tgt-pgt-application-form-step-by-step",
    exam: "KVS TGT/PGT",
    title: "KVS TGT/PGT Application Form — Step-by-Step Apply Online Guide",
    portal: "https://kvsangathan.nic.in/",
    fee_general: "Rs. 1500 (PGT), Rs. 1200 (TGT)",
    fee_reserved: "Nil (SC/ST/PwD/Women)",
    steps: [
      "Register at kvsangathan.nic.in → Recruitment section → Apply Online.",
      "Fill Personal Details + Address.",
      "Fill Educational Qualification — Master's degree (PGT), Bachelor's + B.Ed (TGT).",
      "Choose Subject (Hindi, English, Maths, Sanskrit, Sci, SST etc.).",
      "Upload Photo, Signature, Mark sheets (Class 10, 12, Graduation, B.Ed, Master's).",
      "Choose Exam Centre preferences.",
      "Pay Rs. 1500/1200 via debit/credit card or net banking.",
      "Submit and download application acknowledgment.",
    ],
    common_mistakes: [
      "Forgetting B.Ed mandatory subject — TGT requires B.Ed in the SAME subject.",
      "Uploading Master's in different subject than applied for PGT post.",
    ],
    last_minute: "Verify CTET / state TET certificate validity — must be valid on the date of application submission.",
  },
  {
    slug: "sbi-po-application-form-step-by-step",
    exam: "SBI PO",
    title: "SBI PO Application Form — Step-by-Step Apply Online Guide",
    portal: "https://sbi.co.in/careers",
    fee_general: "Rs. 750",
    fee_reserved: "Nil (SC/ST/PwD)",
    steps: [
      "Go to bank.sbi/careers → Latest Vacancies → SBI PO.",
      "New Registration → Name, DOB, Email, Mobile.",
      "Login → Fill Basic Info, Photo + Signature upload (200×230 / 140×60 px).",
      "Educational Qualification — Bachelor's degree with min 60% (GEN), 55% (SC/ST/PwBD).",
      "Choose Exam Centre (Prelims + Mains separately).",
      "Upload handwritten Declaration (English): 'I, ___, hereby declare that all the information I have provided is true to the best of my knowledge.'",
      "Pay Rs. 750 fee (General/EWS/OBC) via debit card / net banking / UPI.",
      "Final Submit. Save Registration No + Password for future logins.",
    ],
    common_mistakes: [
      "Skipping handwritten declaration — SBI strictly rejects without it.",
      "Filling commerce stream in qualification — accepted but must match degree certificate exactly.",
    ],
    last_minute: "SBI declaration must be in YOUR own handwriting — typed text is rejected. Photo must be in business attire (no t-shirts/casuals).",
  },
  {
    slug: "rrb-group-d-application-form-step-by-step",
    exam: "RRB Group D",
    title: "RRB Group D Application Form — Step-by-Step Apply Online Guide",
    portal: "https://www.rrbcdg.gov.in/",
    fee_general: "Rs. 500 (Rs. 400 refundable)",
    fee_reserved: "Rs. 250 (full refund)",
    steps: [
      "Visit rrbapply.gov.in → Group D Notification → New Registration.",
      "Verify mobile + email OTP.",
      "Choose ONE RRB region only (very critical — region is final once chosen).",
      "Fill Personal Details exactly as Matriculation certificate.",
      "Fill Educational Qualification — Class 10 + ITI / NAC (post-2019 notification needs ITI).",
      "Choose 3 Exam Centres within RRB region.",
      "Upload Photo (15-40 KB) + Signature (10-40 KB).",
      "Pay Rs. 500/250 fee online.",
      "Submit and save Registration Number for life — needed at every stage of recruitment.",
    ],
    common_mistakes: [
      "Treating Group D like NTPC — Group D requires PET (Physical Efficiency Test): male carrying 35 kg for 100m in 2 min.",
      "Not having ITI / NAC for post-2019 notification — Class 10 alone is rejected.",
    ],
    last_minute: "Group D PET is tough — male candidates must lift 35 kg in 2 minutes. Practice the lift drill for 30 days before exam.",
  },
];

export function getFormGuide(slug) {
  return FORM_GUIDES.find((g) => g.slug === slug) || null;
}
